import { worlds } from './worlds'
import { featuredLesson } from '../lib/appAssets'

export interface Discovery {
  topic: string
  question: string
  href: string
  art: { src: string; alt: string; width: number; height: number }
}

function worldPreview(name: string) {
  const world = worlds.find((item) => item.name === name)
  if (!world) throw new Error(`Unknown world: ${name}`)
  return {
    href: `/worlds#${world.slug}`,
    art: { src: world.art, alt: world.alt, width: world.width, height: world.height },
  }
}

const space = worldPreview('Space & Beyond')
const animals = worldPreview('Amazing Animals')
const earth = worldPreview('Our Wild Earth')

/**
 * Homepage teaser. Art is existing catalog art only: the Space & Beyond cover
 * (a ringed planet), the real octopus lesson card, and the Our Wild Earth cover
 * (a volcano). No northern lights artwork exists in the project, so the
 * volcano question is used instead.
 */
export const discoveries: Discovery[] = [
  { topic: 'Space', question: 'Why does Saturn have rings?', ...space },
  {
    topic: 'Animals',
    question: 'Why do octopuses have three hearts?',
    href: animals.href,
    art: {
      src: featuredLesson.heroCard.src,
      alt: featuredLesson.heroCard.alt,
      width: featuredLesson.heroCard.width,
      height: featuredLesson.heroCard.height,
    },
  },
  { topic: 'Our World', question: 'Why do volcanoes erupt?', ...earth },
]
